import { useState } from "react";

function HedgingHorizonsModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Hedging",
      content: [
        "Understanding the concept of hedging and its importance in risk management.",
        "Why every trader and investor should consider hedging their positions.",
      ],
    },
    {
      title: "Module 2: The Basics of Risk in Trading",
      content: [
        "Types of risks in financial markets: market risk, liquidity risk, and volatility risk.",
        "Identifying risk exposure in different asset classes (stocks, commodities, forex, etc.).",
      ],
    },
    {
      title: "Module 3: Hedging with Futures Contracts",
      content: [
        "How to use Futures contracts as a hedge against market risk.",
        "Practical examples of hedging with Futures: equity, commodity, and interest rate Futures.",
      ],
    },
    {
      title: "Module 4: Hedging with Options Contracts",
      content: [
        "Using Options (puts and calls) as a protective hedge.",
        "Understanding how to use protective puts to safeguard against downside risk and covered calls for income generation.",
      ],
    },
    {
      title: "Module 5: Dynamic Hedging Strategies",
      content: [
        "Introduction to dynamic hedging: adjusting positions based on market conditions.",
        "How to implement rolling hedges and partial hedges as market conditions evolve.",
      ],
    },
    {
      title: "Module 6: Cross-Asset Hedging",
      content: [
        "Using correlations to hedge positions across different asset classes (stocks, bonds, commodities).",
        "Benefits and risks of hedging with assets that move in opposite directions.",
      ],
    },
    {
      title: "Module 7: The Greeks in Hedging",
      content: [
        "Understanding Delta, Gamma, Theta, Vega, and Rho in the context of hedging.",
        "Using the Greeks to optimize hedging strategies in Options trading.",
      ],
    },
    {
      title: "Module 8: Hedging Currency Risks",
      content: [
        "Hedging against currency fluctuations with forex options and futures.",
        "How businesses and traders use currency hedging to protect against foreign exchange risk.",
      ],
    },
    {
      title: "Module 9: Commodity Hedging Strategies",
      content: [
        "Protecting against commodity price volatility (e.g., oil, gold, agricultural products).",
        "Practical strategies for hedging commodity price movements using futures and options.",
      ],
    },
    {
      title: "Module 10: Interest Rate Hedging",
      content: [
        "Hedging against interest rate risk using derivatives like swaps, futures, and options.",
        "Key strategies for managing risk in bond portfolios and financial products sensitive to interest rate changes.",
      ],
    },
    {
      title: "Module 11: Portfolio Hedging Techniques",
      content: [
        "Hedging an entire portfolio using ETFs, Futures, and Options.",
        "Using diversification, correlation analysis, and asset allocation to create a balanced portfolio with built-in hedges.",
      ],
    },
    {
      title: "Module 12: The Costs and Benefits of Hedging",
      content: [
        "Evaluating the trade-off between the cost of hedging and the potential protection it provides.",
        "Calculating the effectiveness of hedging in different market scenarios.",
      ],
    },
    {
      title: "Module 13: Advanced Hedging Strategies",
      content: [
        "Complex hedging strategies: Pairs trading, straddle/strangle, and option spreads.",
        "Case studies and real-world examples of advanced hedging techniques in action.",
      ],
    },
    {
      title: "Module 14: Psychology of Hedging",
      content: [
        "The mental aspect of hedging: when to hedge and when not to.",
        "Balancing risk and reward: understanding your risk tolerance and adjusting hedging strategies accordingly.",
      ],
    },
    {
      title: "Module 15: Building Your Hedging Plan",
      content: [
        "How to develop a personalized hedging strategy based on your trading goals and market outlook.",
        "Continual adaptation: how to adjust your hedging plan as market conditions change over time.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">Hedging Horizons</h1>
      <p className="text-center text-muted mb-5">
        Explore the essential strategies to manage risk and safeguard your trading positions.
      </p>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-primary text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default HedgingHorizonsModule;
